import { Box, Container, Stack, Typography } from '@mui/material';
import { useLocales } from 'src/locales';
import quotesIcon from '@iconify/icons-carbon/quotes';
import Iconify from 'src/components/iconify';

interface TeamData {
  name: string;
  role: string;
  description: string;
  image: string;
}

function Team() {
  const { t } = useLocales();
  const teamDatas: TeamData[] = t('teamDatas', { returnObjects: true });
  return (
    <Stack sx={{ mb: 0, pb: 0 }} id="team">
      <Box
        component="img"
        src="/assets/layered-waves.svg"
        alt="pathen"
        width={{ md: '80vw', xs: '100%' }}
        display={{ xs: 'none', md: 'block' }}
      />
      <Stack
        sx={{
          position: { md: 'absolute' },
          left: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '90%',
        }}
      >
        <Container maxWidth="lg">
          <Stack justifyContent="center" alignItems="center" spacing={{ xs: 3, md: 8 }}>
            {teamDatas.map((team) => (
              <Stack
                sx={{ display: 'flex', flexDirection: { md: 'row', xs: 'column' } }}
                px={{ px: 4 }}
              >
                <Box component="img" src={team.image} alt={team.name} sx={{ borderRadius: 3 }} />
                <Stack
                  py={{ xs: 3, md: 0 }}
                  pl={{ md: 10 }}
                  direction={{ xs: 'column', md: 'row' }}
                  justifyContent="center"
                  alignItems="center"
                  spacing={3}
                  borderRadius={1}
                  sx={{
                    transition: 'all 0.3s ease-in-out',
                    '& img': {
                      transition: 'all 0.3s ease-in-out',
                      borderRadius: { xs: 100, md: 4 },
                    },
                  }}
                >
                  <Stack>
                    <Typography variant="overline" sx={{ color: 'text.disabled' }}>
                      {team.role}
                    </Typography>
                    <Typography variant="h4">{team.name}</Typography>

                    <Typography variant="body2" mt={5}>
                      <Iconify
                        icon={quotesIcon}
                        sx={{ width: 48, height: 48, opacity: 0.48, color: 'primary.main' }}
                      />
                      {team.description}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            ))}
          </Stack>
        </Container>
      </Stack>
    </Stack>
  );
}
export default Team;
